import { FIGURE_PALETTE } from '~components/visualisation/figurePalette';

// What each figure colour means on the Budget Tracker (TAV-3442): utilisation in blues, darker = more locked in.
// The tracker and the SaH Dashboard's Budgets tab both read these, so a change here shows on both.
export const TRACKER_FIGURE_COLOURS = {
  claimed: FIGURE_PALETTE.blueDark,
  booked: FIGURE_PALETTE.blueMid,
  remaining: FIGURE_PALETTE.blueLight,
  bookedOverAllocated: FIGURE_PALETTE.amber,
  careManagementUsed: FIGURE_PALETTE.blueMid,
  careManagementOver: FIGURE_PALETTE.amber,
  careManagementRemaining: FIGURE_PALETTE.blueLight,
  statusPill: FIGURE_PALETTE.neutral,
} as const;
